import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'
import { useResortInclusions } from '../../hooks/useResortInclusions'
import ResortInclusionsForm from './ResortInclusionsForm'
import ReactTooltip from 'react-tooltip'
import PlaceholderCheckoutStep2 from './PlaceholderCheckoutStep2'

CheckoutResortStep2.propTypes = {
  roomId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  shopSlug: PropTypes.string.isRequired,
  shopTitle: PropTypes.string.isRequired,
  rate: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  packages: PropTypes.array,
  isFixedPackage: PropTypes.bool.isRequired,
  setRatePrice: PropTypes.func.isRequired,
  setInclusionsPrice: PropTypes.func.isRequired,
  saveSelectedInclusions: PropTypes.func.isRequired,
  shopId: PropTypes.string.isRequired,
  mealPlan: PropTypes.string.isRequired,
}

export default function CheckoutResortStep2({
  roomId,
  shopSlug,
  shopTitle,
  rate,
  packages,
  isFixedPackage,
  setRatePrice,
  setInclusionsPrice,
  saveSelectedInclusions,
  shopId,
  mealPlan,
}) {
  const {
    ratePrice,
    resortData,
    isLoading,
    freeCancellationDays,
  } = useResortInclusions({
    roomId,
    shopSlug,
    shopTitle,
    rate,
    packages,
    isFixedPackage,
    shopId,
    mealPlan,
  })

  useEffect(() => {
    if(ratePrice) {
      setRatePrice(ratePrice)
    }
  }, [ratePrice])

  return (
    <div className='main-content'>
      <ReactTooltip effect='solid' type='dark' id='global' />
      <h2 className='step-title mbn'>
        <span className='number'>2</span>
        <FormattedMessage
          id='tailor_package'
          defaultMessage='Tailor your package'
        />
      </h2>
      {resortData?.requirements && (
        <div className='resort-requirements'>
          <p>
            <FormattedMessage defaultMessage='Requirements for divers:' />
          </p>
          <span
            dangerouslySetInnerHTML={{ __html: resortData?.requirements }}
          />
        </div>
      )}

      {isLoading ? (
        <PlaceholderCheckoutStep2 />
      ) : (
        <ResortInclusionsForm
          saveSelectedInclusions={saveSelectedInclusions}
          resortData={resortData}
          initialValues={{
            resortInclusions: resortData.resortInclusions,
            diversArray: resortData.diversArray,
            nonDiversArray: resortData.nonDiversArray,
            studentsArray: resortData.studentsArray,
            diverCoursesList: resortData.diverCoursesList,
            roomPricingIds: resortData.roomPricingIds,
            insurances: resortData.insurances,
          }}
          isFixedPackage={isFixedPackage}
          setInclusionsPrice={setInclusionsPrice}
          freeCancellationDays={freeCancellationDays}
          showHint
        />
      )}
    </div>
  )
}
